import React, { forwardRef, memo, useState } from 'react';
import { styled, ClassNames } from '@kufox/mui/emotion';
import { Input, Tooltip } from '@kufox/mui';
import { useTranslation } from '@tools/i18n';
import { REGEXP_PWD_GROUP } from '../../common/tools';
import CheckedIcon from '../../../static/checked.svg';
import CheckFailedIcon from '../../../static/check-failed.svg';

const NoticeContainer = styled.ul`
  margin: 0;
  padding: 0;
`;

const NoticeItem = styled.li`
  display: flex;
  align-items: center;
`;

const NoticeText = styled.div`
  margin-left: 4px;
  font-size: 14px;
  line-height: 22px;
  color: #fff;
`;

const ValidIcon = styled.img`
  width: 16px;
`;

const CheckIconComponent = memo((props) => {
  const { isMatch = false } = props;
  return (
    <ValidIcon
      src={isMatch ? CheckedIcon : CheckFailedIcon}
      alt={isMatch ? 'passesd-icon' : 'failed-icon'}
    />
  );
});

function InputEye(props = {}, ref) {
  const { t } = useTranslation('entrance');
  const { value, onFocus, onBlur, ...rest } = props;
  const [showNotice, setShowNotice] = useState(false);
  const isLengthValid = REGEXP_PWD_GROUP.length.test(value || '');
  const isStrValid = REGEXP_PWD_GROUP.str.test(value || '');
  const isSpaceValid = !REGEXP_PWD_GROUP.space.test(value || '');

  const handleFocus = (e) => {
    setShowNotice(true);
    typeof onFocus === 'function' && onFocus(e);
  };

  const handleBlur = (e) => {
    setShowNotice(false);
    typeof onBlur === 'function' && onBlur(e);
  };

  return (
    <ClassNames>
      {({ css }) => {
        const togglePwdClass = css`
          margin-left: 12px;
        `;
        const clearIconClass = css`
          visibility: ${showNotice ? 'visible' : 'hidden'};
        `;

        return (
          <Tooltip
            open={!!value && showNotice}
            placement="top-end"
            title={
              <NoticeContainer>
                <NoticeItem>
                  <CheckIconComponent isMatch={isLengthValid} />
                  <NoticeText>{t('newsignup.pwd.valid.length', { num1: 10, num2: 32 })}</NoticeText>
                </NoticeItem>
                <NoticeItem>
                  <CheckIconComponent isMatch={isStrValid} />
                  <NoticeText>{t('newsignup.pwd.valid.str')}</NoticeText>
                </NoticeItem>
                <NoticeItem>
                  <CheckIconComponent isMatch={isSpaceValid} />
                  <NoticeText>{t('newsignup.pwd.valid.space')}</NoticeText>
                </NoticeItem>
              </NoticeContainer>
            }
          >
            <div>
              <Input
                // allowClear
                classNames={{ togglePwdIcon: togglePwdClass, clearIcon: clearIconClass }}
                type="password"
                value={value}
                onFocus={handleFocus}
                onBlur={handleBlur}
                {...rest}
                ref={ref}
              />
            </div>
          </Tooltip>
        );
      }}
    </ClassNames>
  );
}

export default forwardRef(InputEye);
